module.exports = __webpack_public_path__ + "img/wlsj.549ab4f8.jpg";